import * as React from 'react';
import { PropsWithChildren, ReactNode } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { Hierarchy } from '../../api/core';
import { InternalLink } from './InternalLink';
import { HierarchyBlock } from './HierarchyBlock';

interface Props {
  idx: string;
  hierarchy: Hierarchy[];
  path: 'project' | 'organisation';
  onBeforeShow: () => void;
}

export const HierarchyToolTip: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>): ReactNode => {
  const [idx] = React.useState<string>(`${props.idx}${Math.floor(Math.random() * 1000)}`);
  return (
    <div>
      <Tooltip onBeforeShow={props.onBeforeShow} target={`#${idx}`} pt={{text: {className: 'surface-200 text-900'}}}
               position={'mouse'} event={'both'} autoHide={false}>
        <HierarchyBlock breakpoint={'always'}>
          {(props.hierarchy || []).map((h: Hierarchy, idx2: number): ReactNode => (
            <InternalLink key={idx2} to={`/${props.path}/${h.entityId}`}>{h.name}</InternalLink>
          ))}
        </HierarchyBlock>
      </Tooltip>
      <div id={idx}>{props.children}</div>
    </div>
  );

};
